<style lang="scss" scoped>
.class {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
		}
		display: flex;
		justify-content: space-between
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	&__details {
		&__container {
			padding-left: 1.5rem;
			padding-right: 1.5rem;
			margin-bottom: 1.5rem;
		}
		&__body {
			border-style: solid;
			border-width: 1px;
			border-radius: 0.375rem;
			padding-left: 1.5rem;
			padding-right: 1.5rem;
		}
	}
}
</style>
<template lang="pug">
.class
	app-header
		.class__header(slot="header")
			h1 {{ featureLabel }} ID: {{ $route.params.id }}
			el-button(v-on:click="backToClassrooms") Back to classrooms
	.class__container
		.class__panel
			loading(v-if="$apollo.loading")
			template(v-else)
				class-head(:selectedClass="selectedClass", :owner="owner", v-if="providerCode === 'gapps'")
				group-head(:selectedClass="selectedClass", :owner="owner", v-else)

				el-table.custom-table.overflow(:data="members")
					el-table-column(prop="name", label="Name") 
						template(slot-scope="scope") 
							span {{ scope.row.name }}
					el-table-column(prop="email", label="Email")
						template(slot-scope="scope") 
							span {{ scope.row.emailAddress || 'NO EMAIL' }}
					el-table-column(prop="isOwner", label="Ownership")
						template(slot-scope="scope") 
							span(v-if="scope.row.isOwner && providerCode == 'gapps'") {{ 'Owner' }}
							div(v-else-if="scope.row.isOwner && providerCode == 'msft'")
								el-button(type="danger", :loading="loading", @click="removeOwner(scope.row.id)") Remove as owner
							div(v-else)
								el-button(type="primary", :loading="loading", @click="setOwner(scope.row.id)") Set as owner
</template>

<script>
import gql from "graphql-tag";
import _ from "lodash";
import ClassHead from "./google/ClassHead.vue";
import GroupHead from "./microsoft/GroupHead.vue";

const GET_CLASS = gql`
	query($classId: String!, $members: [String!]!) {
		ThirdPartyClass(classId: $classId, members: $members) {
			id
			name
			courseState
			ownerId
			emailAddress
			members {
				id
				name
				emailAddress
			}
		}
	}
`;

const UPDATE_THIRD_PARTY_CLASS = gql`
	mutation UpdateThirdPartyClass($classId: String!, $properties: ClassProperties!) {
		UpdateThirdPartyClass(data: { classId: $classId, properties: $properties }) {
			id
			ownerId
		}
	}
`;

export default {
	components: {
		ClassHead,
		GroupHead
	},
	data() {
		return {
			ThirdPartyClass: {
				id: null,
				name: "",
				courseState: "",
				ownerId: "",
				members: [],
			},
			classId: 0,
			filters: null,
			loading: false,
		};
	},
	computed: {
		selectedClass() {
			return this.ThirdPartyClass;
		},
		owner() {
			return _(this.ThirdPartyClass.members)
				.filter((member) => {
					return this.ThirdPartyClass.ownerId.split(",").includes(member.id);
				})
				.map((member) => member.name)
				.value();
		},
		members() {
			return this.ThirdPartyClass.members.map((member) => {
				if (member.id === this.ThirdPartyClass.ownerId || (this.ThirdPartyClass.ownerId.split(",").includes(member.id))) {
					member.isOwner = true;
				} else {
					member.isOwner = false;
				}

				return member;
			});
		},
		featureLabel() {
			return ({
				"gapps": "Classroom",
				"msft": "Team"
			})[this.providerCode];
		}
	},

	methods: {
		setOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.ThirdPartyClass.id,
						properties: {
							ownerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
		removeOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.ThirdPartyClass.id,
						properties: {
							removeOwnerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
		backToClassrooms(){
			this.$router.push({name : "classrooms"});
		}
	},

	apollo: {
		// SP Provider Data
		ThirdPartyClass: {
			query: GET_CLASS,
			variables() {
				return {
					classId: this.$route.params.id,
					members: ["teacher"],
				};
			},
			fetchPolicy: "cache-and-network",
		},
	},
};
</script>